<div class="stepper" *ngIf="viewModel$ | async as vm">
  <div
    *ngFor="let step of vm.steps"
    class="step"
    [class.current]="step.current"
    [class.past]="step.past"
    [class.disabled]="step.disabled"
    (click)="
      step.disabled ||
        store.dispatch(
          actions.stepClicked({
            nextStep: step.key,
            currentStep: vm.currentStep,
          })
        )
    "
    [style.cursor]="step.disabled ? 'default' : 'pointer'"
  >
    <span class="step-icon">
      <i
        *ngIf="step.errorMessage; else defaultIcon"
        class="pi pi-times"
        style="color: var(--error)"
      ></i>
      <ng-template #defaultIcon>
        <i *ngIf="step.past" class="pi pi-check"></i>
        <span *ngIf="step.current" class="current-dot"></span>
      </ng-template>
    </span>
    <span
      class="step-title"
      [style.color]="step.errorMessage ? 'var(--error)' : null"
      >{{ step.title }}</span
    >
    <span
      *ngIf="step.errorMessage"
      style="font-style: italic; color: var(--text-color-secondary)"
      >{{ step.errorMessage }}</span
    >
  </div>
</div>
